import { DataGrid } from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

//Tema para limpar as propriedades do bootstrap
const theme = createTheme({
  typography: {
    fontFamily: '"Open Sans", sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        select, input, button {
          font-family: "Open Sans", sans-serif !important;
          line-height: normal !important;
          height: auto;
        }

        .MuiTablePagination-root {
          display: flex;
          align-items: center !important;
          justify-content: space-between;
          padding: 8px 16px;
        }

        .MuiTablePagination-selectLabel,
        .MuiTablePagination-displayedRows {
          margin-top: 0 !important;
          margin-bottom: 0 !important;
          line-height: 1.5 !important;
        }

        .MuiTablePagination-select {
          margin: 0 8px !important;
          height: 32px !important;
          padding: 0 8px !important;
        }

        .MuiTablePagination-select {
          margin: 0 8px !important;
          height: 32px !important;
          padding: 0 8px !important;
          line-height: 1.5 !important;
          vertical-align: middle !important;
          display: inline-flex !important;
          align-items: center !important;
          font-family: "Open Sans", sans-serif !important;
        }

        .MuiSelect-select {
          padding-right: 24px !important;
          display: flex !important;
          align-items: center !important;
          line-height: normal !important;
        }

        .MuiDataGrid-row {
          cursor: pointer;
        }
      `,
    },
  },
});

const CustomDatatable = ({
  columns,
  rows,
  rowCount,
  paginationModel,
  onPaginationModelChange,
  onSortModelChange,
  onRowSelectionModelChange,
  rowSelectionModel,
  checkboxSelection,
  onRowClick,
  pageSizeOptions,
  isRowSelectableForStatus = false,
  isBulk = false,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={{ height: 500, width: "100%" }}>
        <DataGrid
          columns={columns}
          rows={rows}
          rowCount={rowCount}
          pagination
          paginationMode="server"
          sortingMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={onPaginationModelChange}
          onSortModelChange={onSortModelChange}
          onRowSelectionModelChange={(newModel) => {
            onRowSelectionModelChange(newModel)
          }}
          rowSelectionModel={rowSelectionModel}
          keepNonExistentRowsSelected
          isRowSelectable={(params) => {
            if (!isBulk) {
                if (isRowSelectableForStatus && (params.row.status !== "Published" && params.row.status !== "Approved")) {
                return false;
              }
            return true;
            }
            return true;
          }}
          checkboxSelectionVisibleOnly
          disableRowSelectionOnClick
          pageSizeOptions={pageSizeOptions}
          disableColumnFilter
          disableColumnMenu
          disableMultipleRowSelection={false}
          checkboxSelection={checkboxSelection}
          onRowClick={onRowClick}
          hideFooterSelectedRowCount
          localeText={{
            noRowsLabel: "No results found"
          }}
          getRowHeight={() => 'auto'}
          sx={{
            "& .MuiDataGrid-cell": {
              py: 2,                
              display: "flex",
              alignItems: "center",
              whiteSpace: "normal",
              overflowWrap: "anywhere", 
            },
          }}
        />
      </div>
    </ThemeProvider>
  );
};

export default CustomDatatable;
